<div
  class="flex flex-col gap-4"
  style="height: calc(100svh - 85px);"
>
  @if(!this.chatService.selectedTeilaufgabeTable){
  <div
    id="dialog"
    class="flex flex-col gap-5 flex-1 overflow-y-scroll p-5 pb-0"
  >
    @for (item of this.chatService.selectedHistoryItems; track $index) {
    <app-chat-bubble
      [message]="item"
      class="item-end"
    ></app-chat-bubble>
    }
  </div>
  <div class="flex flex-col gap-2">
    @if(this.att.isRecording.value){
    <app-voice-bars></app-voice-bars>
    }
    <div class="flex-0 flex gap-2 items-end p-5 pt-0">
      <textarea
        #chatInput
        class="w-full max-h-[90px] resize-none"
        pTextarea
        rows="1"
        (keydown)="this.onKeyDown($event)"
        (paste)="this.onPaste($event)"
        [(ngModel)]="this.promptInput"
        appAutoResizeToMax
      ></textarea>
      <p-button
        size="small"
        [icon]="'pi ' + (this.att.isProcessing.value ? 'pi-spin pi-spinner' : this.att.isRecording.value ? 'pi-stop-circle' : 'pi-microphone')"
        [severity]="this.att.isRecording.value ? 'danger' : 'primary'"
        [disabled]="this.att.isProcessing.value"
        (onClick)="this.toggleRecording()"
      />
      <p-button
        size="small"
        icon="pi pi-send"
        [disabled]="this.promptInput.trim() == '' || !this.chatService.userInputEnabled"
        (onClick)="this.sendPrompt()"
      />
    </div>
  </div>
  }@else{
  <div class="overflow-y-scroll p-5">
    <app-table></app-table>
  </div>
  }
</div>